import React from 'react';
import { Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems, GitHubButton, ButtonContainer, MobileIcon, MobileMenu, MobileLink } from './NavbarStyledComponent';
import { DiCssdeck } from 'react-icons/di';
import { FaBars } from 'react-icons/fa';
import { Bio } from '../../data/constants';
import { useTheme } from 'styled-components';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme();

  const handleLinkClick = () => {
    setIsOpen(false); // Close the mobile menu when a link is clicked
  };

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
          <a style={{ display: "flex", alignItems: "center", color: "white", marginBottom: '20px', cursor: 'pointer' }} href="/">
            {/* Changed the inner 'a' tag to include the 'href' attribute */}
            <DiCssdeck size="3rem" /> <Span>OMAR ZAROUAL</Span>
          </a>
        </NavLogo>
        <MobileIcon>
          <FaBars onClick={() => setIsOpen(!isOpen)} />
        </MobileIcon>
        <NavItems>
          {/* Added valid 'href' attributes */}
          <NavLink href="#about" onClick={handleLinkClick}>About</NavLink>
          <NavLink href='#skills' onClick={handleLinkClick}>Skills</NavLink>
          <NavLink href='#experience' onClick={handleLinkClick}>Experience</NavLink>
          <NavLink href='#projects' onClick={handleLinkClick}>Projects</NavLink>
          <NavLink href='#education' onClick={handleLinkClick}>Education</NavLink>
        </NavItems>
        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank">Github Profile</GitHubButton>
        </ButtonContainer>
        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            {/* Updated 'MobileLink' components with valid 'href' attributes */}
            <MobileLink href="#about" onClick={handleLinkClick}>About</MobileLink>
            <MobileLink href='#skills' onClick={handleLinkClick}>Skills</MobileLink>
            <MobileLink href='#experience' onClick={handleLinkClick}>Experience</MobileLink>
            <MobileLink href='#projects' onClick={handleLinkClick}>Projects</MobileLink>
            <MobileLink href='#education' onClick={handleLinkClick}>Education</MobileLink>
            <GitHubButton style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }} href={Bio.github} target="_blank">Github Profile</GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
